import { type ApolloClient } from "@apollo/client";

import { type PaginationContext } from "../../common/state";
import { GroupsRepositoryV2 } from "../model/GroupsRespositoryV2";

export const loadGroups =
    (client: ApolloClient<any>) =>
    ({ limit, offset }: PaginationContext) =>
        new GroupsRepositoryV2(client).loadGroupsToCache({ limit, offset }).then((groups) => ({
            isLastPage: (groups?.length ?? 0) < limit,
        }));
